import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HasClassName } from '../component-utils';
import { useSelector } from '../hook-utils';
import { isQueueId, QueueStats, QueueRegionId, Squad } from '../model';
import { actions } from '../store';
import { selectSelectedQueueView } from '../store/reducers/localSettings';
import { selectQueues } from '../store/reducers/queues';
import { selectSquads } from '../store/reducers/squads';
import { useTeams } from '../TeamsProvider';
import DropdownButton from './DropdownButton';
import Input from './Input';
import { MenuItem } from './Menu';
import { getQueueRegionName, QueueRegionDropdownItems } from './RegionDropdownItems';
import './TeamsTabConfig.scss';

interface Props extends HasClassName {
}

export default function TeamsTabConfig({ className }: Props) {
  const dispatch = useDispatch()
  const teams = useTeams()
  const view = useSelector(selectSelectedQueueView)
  const queues: Array<QueueStats | Squad> | null = useSelector(s => view.region === QueueRegionId.Squads ? selectSquads(s) : view.region ? selectQueues(s, view.region) : [])
  const [queue, setQueue] = useState<QueueStats | Squad>()
  const [name, setName] = useState('')

  useEffect((() => {
    if (view.region) {
      dispatch(actions.fetchQueues.request({ region: view.region }))
    }
    setQueue(undefined)
  }), [dispatch, view])

  const onQueueSelected = (queue: QueueStats | Squad) => {
    setQueue(queue)
    setName(getDescription(queue))
  }

  useEffect(() => {
    if (teams.inTeams && queue) {
      const { id, server, type } = queue
      teams.setSettings({ showId: { id, server, type } }, name)
    }
  }, [name, queue, teams])

  return <div className={classNames('TeamsTabConfig', className)}>
    <h1>Select the queue to display</h1>
    <DropdownButton setWidth items={<QueueRegionDropdownItems />}>
      {view.region ? getQueueRegionName(view.region) : view.queue.id}
    </DropdownButton>
    <DropdownButton setWidth items={queues && queues.map(queue => <MenuItem key={queue.id} onClick={() => onQueueSelected(queue)}>
      {getDescription(queue)}
    </MenuItem>)}>
      {queue && getDescription(queue)}
    </DropdownButton>

    <label>
      Tab name
      <Input value={name} onChange={e => setName(e.currentTarget.value)} autocomplete={false} />
    </label>
  </div>
}

function getDescription(queueOrSquad: QueueStats | Squad) {
  return isQueueId(queueOrSquad) ? `${queueOrSquad.id} ${queueOrSquad.description}` : queueOrSquad.description
}
